import { apiEndpoint, retryApi } from ".";

export interface ReadEntryRequest {
  readonly name: string;
  readonly skipRetry?: boolean;
}
export interface ReadEntryResponse {
  readonly name: string;
  readonly value: string;
}

export async function readEntry(
  req: ReadEntryRequest,
): Promise<ReadEntryResponse | undefined> {
  const name = req.name;
  const token = localStorage.getItem("authToken");
  if (token) {
    const response = await fetch(
      `${apiEndpoint}/parameter/${encodeURIComponent(name)}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    );
    if (!response.ok) {
      // TODO - make this a function
      if ([401, 403].includes(response.status) && !req.skipRetry) {
        return retryApi({
          func: readEntry,
          funcProps: { name },
          response,
          token,
        });
      }
      throw new Error(`Failed to get parameter: ${response.statusText}`);
    }
    const res = await response.json();
    const parsedRes = JSON.parse(res);
    return parsedRes as ReadEntryResponse;
  }
}
